export default __webpack_public_path__ + "static/media/csv-file-name.dc8f596e.svg";